"use strict";

/**
 * Konsolen-Events.
 *
 * @enum {string}
 */
gc.gis.module.GCErrorConsoleEvent = {
	/**
	 * Wird ausgelöst, wenn ein Log-GCLogLevel an- oder ausgeschalten wird.
	 * @event gc.gis.module.GCErrorConsoleEvent#toggle:filter
	 * @property {gc.gis.log.GCLogLevel} level (De-)aktiviertes Log-Level
	 */
	FILTER_TOGGLE: 'toggle:filter'
};


/**
 * @classdesc
 * Fehlerkonsolen-Modul.
 *
 * @abstract
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object<string,*>} options Aufrufoptionen
 * @param {string} [options.label='Fehlerkonsole'] Label
 */
gc.gis.module.GCErrorConsole = function( options )
{
	gc.gis.module.GCAbstractModule.call( this, options );

	var self = this;

	this._filter = {};
	this._filter[gc.gis.log.GCLogLevel.ERROR]   = true;
	this._filter[gc.gis.log.GCLogLevel.WARNING] = true;
	this._filter[gc.gis.log.GCLogLevel.INFO]    = false;
	this._filter[gc.gis.log.GCLogLevel.DEBUG]   = false;

	this.active = gc.gis.GCUtil.parseBool( options.active, false );

	this.element_launcher = new gc.gis.widget.GCItem({
		icon: 'glyphicon glyphicon-comment',
		containerClassName: 'gc-footer-component',
		tooltip: 'Logbuch anzeigen/verstecken',
		badge: new gc.gis.widget.GCBadge({
			init: function() {
				var b = this;
				gc.gis.iface.log.on( gc.gis.log.GCLogEvent.MESSAGE, b, function( evt ) {
					b.update();
				});
				gc.gis.iface.log.on( gc.gis.log.GCLogEvent.CLEAR, b, function( evt ) {
					b.update();
				});
				self.on( gc.gis.module.GCErrorConsoleEvent.FILTER_TOGGLE, b, function( evt ) {
					b.update();
				});
				this.update();
			},
			update: function() {
				this.clear();
				var count = 0;
				if( self.isLevelEnabled( gc.gis.log.GCLogLevel.ERROR ) ) {
					count += gc.gis.iface.log.getMessageCount( gc.gis.log.GCLogLevel.ERROR )
				}
				if( self.isLevelEnabled( gc.gis.log.GCLogLevel.WARNING ) ) {
					count += gc.gis.iface.log.getMessageCount( gc.gis.log.GCLogLevel.WARNING )
				}
				if( self.isLevelEnabled( gc.gis.log.GCLogLevel.INFO ) ) {
					count += gc.gis.iface.log.getMessageCount( gc.gis.log.GCLogLevel.INFO )
				}
				if( self.isLevelEnabled( gc.gis.log.GCLogLevel.DEBUG ) ) {
					count += gc.gis.iface.log.getMessageCount( gc.gis.log.GCLogLevel.DEBUG )
				}
				if( count > 0 )
				{
					this.element.html('<span class="gc-badge-value">'
						+ count
						+'</span> <span class="gc-badge-unit">'+ (count===1?'Meldung':'Meldungen') +'</span>');
					this.element.removeClass('gc-empty hidden');
				}
				else
				{
					this.element.addClass('gc-empty hidden');
				}
			}
		}),
		click: function() {
			gc.gis.iface.ui.showDialog({
				title: self.label || 'Fehlerkonsole',
				type: gc.gis.widget.GCDialogType.MESSAGE,
				content: self.element_panel.getElement(),
				cancel: function( evt ) {
					self.element_panel.getElement().detach();
				}
			});
		}
	});

	this.element_panel = new gc.gis.module.GCErrorConsole.Panel({
		module: self,
		active: self.active,
		widget: {
			className: 'gc-errorconsole',
			target: '#gc_errorconsole',
			headline: 'Logbuch',
			toolbar: {
				containerClassName: 'toolbar',	// FIXME: .toolbar -> .widget-toolbar
				items: [
					new gc.gis.widget.GCMenu({
						label: 'Menü',
						className: 'btn btn-default',
						items: [
							[
								new gc.gis.widget.GCToggleItem({
									label:  'Debugmodus aktivieren',
									active: gc.gis.iface.DEBUG,
									action: new gc.gis.module.GCErrorConsole.ToggleDebugAction({
										instance: self
									})
								}),
								new gc.gis.widget.GCItem({
									label:  'Debuginformationen kopieren',
									action: new gc.gis.module.GCErrorConsole.DumpAction({
										instance: self
									})
								})
							],
							[
								new gc.gis.widget.GCItem({
									label:  'Leeren',
									action: new gc.gis.module.GCErrorConsole.ClearAction({
										instance: self
									})
								})
							]
						]
					}),
					new gc.gis.widget.GCToggleItem({
						label:  'Fehler',
						className: 'btn btn-default',
						active: self.isLevelEnabled( gc.gis.log.GCLogLevel.ERROR ),
						action: new gc.gis.module.GCErrorConsole.FilterAction({
							instance: self,
							level: gc.gis.log.GCLogLevel.ERROR
						}),
						badge: self.__createBadge( gc.gis.log.GCLogLevel.ERROR )
					}),
					new gc.gis.widget.GCToggleItem({
						label:  'Warnungen',
						className: 'btn btn-default',
						active: self.isLevelEnabled( gc.gis.log.GCLogLevel.WARNING ),
						action: new gc.gis.module.GCErrorConsole.FilterAction({
							instance: self,
							level: gc.gis.log.GCLogLevel.WARNING
						}),
						badge: self.__createBadge( gc.gis.log.GCLogLevel.WARNING )
					}),
					new gc.gis.widget.GCToggleItem({
						label:  'Infos',
						className: 'btn btn-default',
						active: self.isLevelEnabled( gc.gis.log.GCLogLevel.INFO ),
						action: new gc.gis.module.GCErrorConsole.FilterAction({
							instance: self,
							level: gc.gis.log.GCLogLevel.INFO
						}),
						badge: self.__createBadge( gc.gis.log.GCLogLevel.INFO )
					}),
					new gc.gis.widget.GCToggleItem({
						label:  'Debug',
						className: 'btn btn-default',
						active: self.isLevelEnabled( gc.gis.log.GCLogLevel.DEBUG ),
						action: new gc.gis.module.GCErrorConsole.FilterAction({
							instance: self,
							level: gc.gis.log.GCLogLevel.DEBUG
						}),
						badge: self.__createBadge( gc.gis.log.GCLogLevel.DEBUG )
					})
				]
			}
		}
	});

	gc.gis.iface.ui.attach( this.element_launcher.getElement(), {
		target: gc.gis.iface.ui.footer.main,
		order:  0
	});
	gc.gis.iface.ui.attach( this.element_panel, {
		target: gc.gis.iface.ui.main,
		order: -1
	});

	gc.gis.iface.log.on( gc.gis.log.GCLogEvent.MESSAGE, this, function( evt ) {
		self.onMessageLogged( evt );
	});
	gc.gis.iface.log.on( gc.gis.log.GCLogEvent.CLEAR, this, function( evt ) {
		self.onMessagesCleared();
	});
};
gc.gis.module.GCErrorConsole.prototype = Object.create( gc.gis.module.GCAbstractModule.prototype );

/**
 * Erstellt ein neues Badge, welches auf Nachrichten eines bestimmten Log-Levels
 * hört und darauf reagiert.
 *
 * @private
 * @method
 *
 * @param opt_level
 * @returns {gc.gis.widget.GCBadge}
 */
gc.gis.module.GCErrorConsole.prototype.__createBadge = function( opt_level )
{
	return new gc.gis.widget.GCBadge({
		init: function() {
			var b = this;
			gc.gis.iface.log.on( gc.gis.log.GCLogEvent.MESSAGE, b, function( evt ) {
				b.update();
			});
			gc.gis.iface.log.on( gc.gis.log.GCLogEvent.CLEAR, b, function( evt ) {
				b.update();
			});
			this.update();
		},
		update: function() {
			this.clear();
			var count = gc.gis.iface.log.getMessageCount( opt_level );
			if( count > 0 )
			{
				this.element.html('<span class="gc-badge-value">'
					+ count
					+'</span> <span class="gc-badge-unit">'+ (count===1?'Meldung':'Meldungen') +'</span>');
				this.element.removeClass('gc-empty hidden');
			}
			else
			{
				this.element.addClass('gc-empty hidden');
			}
		}
	});
};

/**
 * (De-)aktiviert die Anzeige von Meldungen eines bestimmten Log-Levels.
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogLevel} level
 * @param {boolean} enabled
 */
gc.gis.module.GCErrorConsole.prototype.setLevelEnabled = function( level, enabled )
{
	this._filter[level] = enabled === true;
};

/**
 * Werden Meldungen eines bestimmten Log-Levels angezeigt?
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogLevel} level
 * @return {boolean}
 */
gc.gis.module.GCErrorConsole.prototype.isLevelEnabled = function( level )
{
	return this._filter[level] === true;
};

/**
 * Callback, wenn eine Log-Meldung abgesetzt wird.
 *
 * @public
 * @method
 *
 * @param {gc.gis.log.GCLogEvent} evt
 */
gc.gis.module.GCErrorConsole.prototype.onMessageLogged = function( evt )
{
	this.element_panel.onMessageLogged( evt );
};

/**
 * Callback, wenn die Log-History gelöscht wird.
 */
gc.gis.module.GCErrorConsole.prototype.onMessagesCleared = function()
{
	this.element_panel.clear();
};
